export default "__VITE_ASSET__DGxBzylw__"